import { mixins, styled } from '@bob/library'

export const Title = styled.h1`
  ${mixins.typography.headlineXl}
  ${mixins.margin.top(5)}
  ${mixins.margin.bottom(30)}
`

export const SideBySideWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${mixins.media.min.phone} {
    flex-wrap: nowrap;
  }
`

export const HalfWrapper = styled.div`
  width: 100%;
  max-width: 660px;

  &:not(:first-child) {
    ${mixins.media.min.phone} {
      ${mixins.padding.left(30)}
    }
  }
`

export const OverviewWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const InfoWrapper = styled.div`
  display: flex;
  ${mixins.margin.right(30)}
  margin-top: 25px;
  align-items: center;
  color: ${({ theme }) => theme.color.gray};
  margin-bottom: 2rem;
  & > svg {
    fill: ${({ theme }) => theme.color.gray};
    ${mixins.margin.right(10)}
  }
`

export const Description = styled.div`
  & > p:first-child {
    margin-top: 0;
  }
`

export const LessonSubjects = styled.div`
  margin-bottom: 25px;
  ${mixins.media.min.tablet} {
    margin-top: 64px;
  }
  color: ${({ theme }) => theme.color.link};
`

export const ProductName = styled.div`
  color: ${({ theme }) => theme.color.link};
`
